<template>
  <a-row class="filter" type="flex" justify="end">
    <a-col style="margin-right: 12px">
      <a-select
        ref="select"
        v-model:value="query.revisitType"
        placeholder="状态"
        style="width: 120px"
        :options="revisitTypeOptions"
        @change="$event => (query.revisitType = $event)"
      ></a-select>
    </a-col>
    <a-col style="margin-right: 12px">
      <a-select
        ref="select"
        v-model:value="query.status"
        placeholder="状态"
        style="width: 120px"
        :options="reserceStateOptions"
        @change="$event => (query.status = $event)"
      ></a-select>
    </a-col>
    <a-col>
      <CusButton style="width: 80px" type="primary" @click="emits('changeQuery', query)">
        搜索
      </CusButton>
    </a-col>
    <a-col>
      <CusButton v-if="props.isReserve" class="reserveButton" @click="openReserve" type="primary">
        预约挂号
      </CusButton>
    </a-col>
  </a-row>
</template>
<script setup>
import { defineEmits, reactive, onMounted, computed, defineProps } from 'vue'
import CusButton from '@/components/cus-Button'
import Config from '@/config/index'
const props = defineProps({
  isReserve: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['changeQuery', 'onReserve', 'onReserve'])

const revisitTypeOptions = [
  {
    value: null,
    label: '全部'
  },
  {
    value: 1,
    label: '线上问诊'
  },
  {
    value: 2,
    label: '门诊就诊'
  }
]
const reserceStateOptions = computed(() => {
  const res = Object.keys(Config.RESERCE_STATE_MAP).map(key => {
    return {
      value: key,
      label: Config.RESERCE_STATE_MAP[key]
    }
  })
  res.unshift({
    value: null,
    label: '全部'
  })
  return res
})

onMounted(() => {
  emits('changeQuery', query)
})
function openReserve() {
  emits('openReserve')
}

const query = reactive({
  status: null,
  revisitType: null
})
</script>
<style lang="scss" scoped>
.filter {
  margin-bottom: 10px;
  .reserveButton {
    margin-left: 10px;
  }
}
</style>
